/* eslint-disable no-unused-vars */
/** @module Auth0PreLoginHandlerMfa */
/* eslint-disable import/extensions */
import Auth0PreLoginHandlerBase from '../auth0-pre-login-handler-base.mst.mjs';
import Auth0MfaCodePageHelper from '../../../pages/auth0-mfa-code-page-helper.mst.mjs';

class Auth0PreLoginHandlerMfa extends Auth0PreLoginHandlerBase {
  _shouldHandleSync = () => {
    return this._qs.get('mfa') === 'email';
  };

  /**
   * @inheritdoc
   */
  async shouldHandle() {
    return Promise.resolve(this._shouldHandleSync());
  }

  /**
   * @inheritdoc
   */
  async run(viewOptions = {}) {
    const mfaFactorType = this._qs.get('mfa');
    console.log('Auth0PreLoginHandlerMfa.run() starts for type =>', mfaFactorType);

    await new Auth0MfaCodePageHelper({
      mfaFactorType,
      mfaGrantToken: this._qs.get('session_token'),
      mfaState: this._qs.get('state'),
      name: 'Auth0MfaCodePageHelper',
      tenantOrDomain: this._tenant.id,
      whiteLabelOptions: this._whiteLabelOptions,
      appLoginUrl: this._appLoginUrl,
      clientId: this._clientId,
      shouldRenderRememberMe: true,
    }).render();

    return true;
  }
}

export default Auth0PreLoginHandlerMfa;
